<div>
    <p>{{ getPriorityLabel() }}</p>

    <table>
        <tr>
            <th></th>
            <th>
                <div class="header">
                    <mat-icon svgIcon="weather-sunny"></mat-icon>HO
                </div>
            </th>
            <th>
                <div class="header">
                    <mat-icon svgIcon="weather-night"></mat-icon>HNO
                </div>
            </th>
        </tr>

        <tr>
            <td>GTI</td>
            <td>
                {{ sla.guaranteedReplyTime }}
            </td>
            <td>
                {{ sla.guaranteedReplyTimeNbh }}
            </td>
        </tr>

        <tr>
            <td>GTR</td>
            <td>
                {{ sla.guaranteedResponseTime }}
            </td>
            <td>
                {{ sla.guaranteedResponseTimeNbh }}
            </td>
        </tr>
    </table>
</div>
